import { z } from 'zod';

const ValidateService = {
    isValidEmail: (email: string) => {
        const result = z.string().min(1).max(256).email().safeParse(email).success;
        if (!result) {
            return false;
        }
        if (email.endsWith('gmail.co')) {
            return false;
        }
        if (email.endsWith('gmail.com') && email.indexOf('@') < 6) {
            return false;
        }
        return true;
    },
};

export default ValidateService;
